import { ref } from "vue";
import { defineStore } from 'pinia';
import axios, { AxiosRequestConfig } from "axios";
import { Patient } from "@/vue/types/patient";

type PatientStoreRequestParams = {
    with?: string[]
    signal?: AbortSignal
};

export const usePatientStore = defineStore('patientStore', () => {
    const patient = ref<Patient>();

    const updatePatient = async (_patient: Patient) => {
        const { data } = await axios.patch(`/api/patients/${_patient.id}`, _patient);
        patient.value = data.data;
    };

    const getPatient = async (id: number, params?: PatientStoreRequestParams) => {
        const requestParams: AxiosRequestConfig['params'] = {};

        if (params?.with) {

            requestParams.with = params.with.join(",");
        }

        const { data } = await axios.get(`/api/patients/${id}`, {
            params: requestParams,
            signal: params?.signal
        });

        patient.value = data.data;
    };

    return {
        patient,
        getPatient,
        updatePatient,
    };
});
